import actionTypes from "./actionTypes";
import api from "./api";
export default {
    saveProject: (project) => ({
        type: actionTypes.SAVE_PROJECT,
        payload: {
            promise: () => api.saveProject(project)
        },
        scope: `${actionTypes.SAVE_PROJECT}_${project.Id}`
    }),
    setDraft: (draft) => ({
        type: actionTypes.SET_DRAFT,
        draft
    }),
    getProject: (projectId) => ({
        type: actionTypes.GET_PROJECT,
        payload: {
            promise: () => api.getProject(projectId)
        },
        scope: `${actionTypes.GET_PROJECT}_${projectId}`
    }),
    setProjectId: (projectId) => ({
        type: actionTypes.SET_PROJECT_ID,
        projectId
    }),
    setNewProject: (workSpaceId) => ({
        type: actionTypes.SET_NEW_PROJECT,
        workSpaceId
    })
};
